import { Observable } from 'rxjs';
import * as RestService from '../_config/rest';

export function rxFetch(request) {
  return Observable.from(request);
}
